import * as React from 'react';

import withCustomLabelsByDegreeId from 'bundles/custom-labels/hoc/withCustomLabelsByDegreeId';
import type { ReplaceCustomContent } from 'bundles/custom-labels/types/CustomLabels';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/CourseHeader';

type InputProps = {
  degreeId: string;
};

type Props = InputProps & {
  replaceCustomContent: ReplaceCustomContent;
};

export const CourseHomeText = ({ replaceCustomContent }: Props) => {
  const courseHomeText = replaceCustomContent(_t('{capitalizedCourse} Home'));

  return <span>{courseHomeText}</span>;
};

export default withCustomLabelsByDegreeId<InputProps>(CourseHomeText);
